import React, { useEffect } from 'react';
import DropdownSelect from '../../atoms/dropdown-select/DropdownSelect';
import { useSelector } from 'react-redux';
import { getCompanyDomains } from '../../../redux/companySlice';

const DomainSelector = ({ name, value, onChange }) => {
  const domains = useSelector((state) => getCompanyDomains(state)) || [];

  // react-dropdown chokes on options whose `value` or `label` is undefined/null
  // (the company's "default" domain entry has no id, so it would inject
  // {value: undefined, label: <env>} and crash the render the moment the user
  // opens or selects from the dropdown). Coerce to strings and drop entries
  // that don't have a usable label.
  const options = domains
    .filter((domain) => domain && (domain.name || domain.subdomain))
    .map((domain) => ({
      value: domain.id != null ? String(domain.id) : '',
      label: String(domain.name || domain.subdomain || '')
    }));

  // Normalize the incoming value to a string so option lookup uses ===-safe
  // comparison (Redux may store the id as either a number or string).
  const normalizedValue = value != null ? String(value) : '';
  const selected = options.find((option) => option.value === normalizedValue);

  const handleChange = (data) => {
    if (!data) return;
    onChange({
      target: {
        name,
        value: data.value,
        label: data.label
      }
    });
  };

  useEffect(() => {
    if (normalizedValue && selected) {
      onChange({
        target: {
          name,
          value: normalizedValue,
          label: selected.label
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DropdownSelect
      name={name}
      value={selected}
      label={'Select a domain or subdomain'}
      placeholder={'Select a domain or subdomain'}
      options={options}
      onChange={handleChange}
    />
  );
};

DomainSelector.defaultProps = {
  name: '',
  value: '',
  onChange: () => { }
};

export default DomainSelector;
